module.exports = __webpack_public_path__ + "45bcc7574d9ddc96916434a161144c86.pdf";